<template lang="html">
  <div class="home">
    <v-row>
      <v-col>
        <SorobanQuotes />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import SorobanQuotes from '@/components/SorobanQuotes.vue'

export default {
  data(){
    return{
      animationOn: false,
    }
  },
  components: {
    SorobanQuotes,
  },
}
</script>

<style lang="scss" scoped>
</style>
